import type { Directive } from 'vue';
declare const vAlignDirective: Directive;
export default vAlignDirective;
